/**
 * Fund Detail Page Route
 *
 * Displays comprehensive information about a single mutual fund including
 * header, score breakdown, performance, rating history, and fund info.
 *
 * Route: /explore/:fundId where fundId is the ISIN
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FundDetailScreen } from "@/components/fund-detail";
import { GlobalErrorFallback } from "@/components/error";

export const Route = createFileRoute("/explore/$fundId")({
  component: FundDetailPage,
  errorComponent: GlobalErrorFallback,
});

function FundDetailPage() {
  const { fundId } = Route.useParams();
  const navigate = useNavigate();

  // Use the FundDetailScreen component which handles all the data fetching and display
  return (
    <FundDetailScreen
      fundId={fundId}
      onBack={() => navigate({ to: "/explore" })}
    />
  );
}
